import React, {useState, useEffect, useRef} from "react";
import {Link, useNavigate} from "react-router-dom";
import api, {requestFailed} from "../Scripts/api";
import errorFlash from "../Scripts/errorFlash";
import PostTag from "./PostTag";

function ExploreBar(props) {

    const navigate = useNavigate()
    const account = props.account
    const tags = props.tags
    const [inputState, setInputState] = useState("tag")
    const [inputValue, setInputValue] = useState('')
    const inputRef = useRef()
    const [errorMessage, setErrorMessage] = useState()

    const handleInput = (event) => {
        setErrorMessage()
        setInputValue(event.target.value.toLowerCase())
    }

    const handleKeyDown = (event) => {
        if (event.key === "Control") setInputState(inputState == "tag" ? "user" : "tag")
        if (event.key === "Enter") {
            if (inputState == "tag") {
                const tagRegex = /^(?=.{1,32}$)[a-z0-9]+$/
                if (!inputValue) {
                    setErrorMessage("invalid tag")
                    errorFlash(inputRef)
                } else if (tagRegex.test(inputValue)) {
                    props.addTag(inputValue)
                    inputRef.current.style.animation = ''
                    event.target.value = ''
                    setInputValue('')
                } else {
                    setErrorMessage("invalid tag")
                    errorFlash(inputRef)
                }
            } else {
                getAccount()
            }
        }
    }

    const getAccount = () => {
        api.get(`/api/getaccount`, {
            params: {account: inputValue}
        }).then((response) => {
            if (response.data.accountExists) navigate("/@" + inputValue + "/profile")
            else {
                setErrorMessage("user not found")
                errorFlash(inputRef)
            }
        }).catch(requestFailed)
    }

    const [allTrends, setAllTrends] = useState([])

    useEffect(() => {
        api.get(`/api/gettrends`).then((response) => {
            if (response.data) setAllTrends(response.data)
        }).catch(requestFailed)
    }, [])

    const trends = allTrends.filter(tag => !tags.includes(tag))

    return (
        <div id="explorebar">
            <div>
                <div>
                    <h3 onClick={() => setInputState(inputState == "tag" ? "user" : "tag")}>Search {inputState == "tag" ? '#' : '@'}</h3>
                    <input ref={inputRef} id="exploreinput" onChange={handleInput} onKeyDown={handleKeyDown} placeholder={inputState}></input>
                    {errorMessage && <pre id="exploreerror">{errorMessage}</pre>}
                </div>
                <div>
                    {tags?.map((item, key) => <PostTag className="posttag posttagactive" key={key} tag={item} onClick={() => props.removeTag(item)}/>)}
                    {trends?.map((item, key) => <PostTag className="posttag" key={key} tag={item} onClick={() => props.addTag(item)}/>)}
                </div>
            </div>
            <Link to={account ? "/create" : "/login"} state={account ? null : {redirect: "/create"}}><button id="createbutton">+ create</button></Link>
        </div>
    )
}

export default ExploreBar